import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Badge from '../../../Badge/Badge'
import { getAssetLink } from '../../../../helpers/get-asset-link'

const ImagesItem = ({ images, previewCount = 2, setPicturesToShow = () => {} }) => {
  const { t } = useTranslation(['internal-inspections'])
  return (
    <div className="images-item">
      <div>
        {images.length > previewCount ? (
          <div>
            <Badge>{`+${images.length - previewCount}`}</Badge>
            <span
              className="details-label view-photos"
              onClick={() => setPicturesToShow({ data: images, index: 0 })}
            >
              <u>{t('internal-inspections:locationItem.viewAllPhotos')}</u>
            </span>
          </div>
        ) : null}
      </div>
      <div>
        {images
          .slice(0, previewCount)
          .map((photo, index) =>
            photo ? (
              <img
                key={photo}
                src={getAssetLink({ path: 'inspection_photos', file: photo })}
                onClick={() => setPicturesToShow({ data: images, index })}
              />
            ) : null,
          )}
      </div>
    </div>
  )
}

ImagesItem.propTypes = {
  images: PropTypes.array,
  previewCount: PropTypes.number,
  setPicturesToShow: PropTypes.func,
}

export default ImagesItem
